webpackJsonp([35783957827783],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _gatsbyImage = __webpack_require__(63);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArticleListItem = function (_React$Component) {
	  _inherits(ArticleListItem, _React$Component);
	
	  function ArticleListItem() {
	    _classCallCheck(this, ArticleListItem);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ArticleListItem.prototype.render = function render() {
	    var article = this.props.node;
	    var tags = article.tags;
	
	
	    return _react2.default.createElement(
	      "div",
	      { key: article.slug, className: "c-article-list" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/articole/" + article.slug + "/", className: "c-link-simple" },
	        article && article.cover && article.cover.resolutions && article.cover.resolutions.src && _react2.default.createElement(_gatsbyImage2.default, {
	          className: "c-article-list__cover",
	          alt: article.cover.title,
	          resolutions: article.cover.resolutions
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "c-article-list__content" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/articole/" + article.slug + "/", className: "c-link-simple" },
	          _react2.default.createElement(
	            "h3",
	            { className: "c-article-list__title u-h3" },
	            article.title
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "c-article-misc" },
	          _react2.default.createElement(
	            "div",
	            { className: "c-article-date" },
	            _react2.default.createElement(
	              "ul",
	              { className: "o-list-inline o-list-05 u-mb-0 o-media__body" },
	              _react2.default.createElement(
	                "li",
	                { className: "o-list-inline__item" },
	                article.date
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "u-ph-10 c-article-misc__separator" },
	            "|"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "c-article-tags" },
	            _react2.default.createElement(
	              "ul",
	              { className: "o-list-inline o-list-05 u-mb-0 o-media__body" },
	              tags.map(function (tag, i) {
	                return _react2.default.createElement(
	                  "li",
	                  { key: i, className: "o-list-inline__item" },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: "/articole/etichete/" + tag.slug + "/", className: "c-tag" },
	                    tag.name
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          { className: "c-article-list__excerpt" },
	          article.excerpt,
	          "..."
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/articole/" + article.slug + "/", className: "c-link u-font-size-15" },
	          "CITESTE MAI DEPARTE"
	        )
	      )
	    );
	  };
	
	  return ArticleListItem;
	}(_react2.default.Component);
	
	exports.default = ArticleListItem;
	module.exports = exports["default"];

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _articleListItem = __webpack_require__(40);
	
	var _articleListItem2 = _interopRequireDefault(_articleListItem);
	
	var _propTypes = __webpack_require__(7);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _reactHelmet = __webpack_require__(168);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _blocuriAministrareImobileNicad = __webpack_require__(459);
	
	var _blocuriAministrareImobileNicad2 = _interopRequireDefault(_blocuriAministrareImobileNicad);
	
	var _documenteAdministrareImobile = __webpack_require__(460);
	
	var _documenteAdministrareImobile2 = _interopRequireDefault(_documenteAdministrareImobile);
	
	var _hartaPrestariServiciiAdministrareImobile = __webpack_require__(461);
	
	var _hartaPrestariServiciiAdministrareImobile2 = _interopRequireDefault(_hartaPrestariServiciiAdministrareImobile);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import lozad from '../../node_modules/lozad'
	
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  // componentDidMount() {
	  //   const observer = lozad('.lozad', {
	  //     rootMargin: '10px 0px', // syntax similar to that of CSS Margin
	  //     threshold: 0.1 // ratio of element convergence
	  //   });
	  //   observer.observe();
	  // }
	  IndexPage.prototype.render = function render() {
	    var data = this.props.data.allContentfulArticle.edges;
	
	    function dmyOrdD(a, b) {
	      return myDate(b) - myDate(a);
	    }
	    function myDate(s) {
	      var a = s.split(/-|\//);return new Date(a[2], a[1] - 1, a[0]);
	    }
	
	    data.sort(function (a, b) {
	      return new Date(b.node.date) - new Date(a.node.date);
	    });
	
	    var articles = data.slice(0, 3);
	
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "c-hero" },
	        _react2.default.createElement("div", { className: "c-hero__stripe c-hero__stripe--1" }),
	        _react2.default.createElement("div", { className: "c-hero__stripe c-hero__stripe--2" }),
	        _react2.default.createElement(
	          "div",
	          { className: "o-container o-container--large c-hero__container" },
	          _react2.default.createElement(
	            "div",
	            { className: "c-hero__content" },
	            _react2.default.createElement(
	              "h1",
	              { className: "c-hero__h1" },
	              "Administram imobile si ansambluri rezidentiale."
	            ),
	            _react2.default.createElement(
	              "p",
	              { className: "c-hero__p" },
	              "Oferim management adaptat cerintelor dumneavoastra si necesitatilor imobilului in care locuiti."
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                onClick: function onClick(e) {
	                  ga('send', 'event', { eventCategory: 'Homepage CTA new', eventAction: 'Button click', eventLabel: 'Vezi lista preturi' });
	                },
	                to: "/servicii/",
	                className: "c-button"
	              },
	              "Descopera serviciile noastre"
	            )
	          ),
	          _react2.default.createElement("img", { className: "c-hero__img", src: _blocuriAministrareImobileNicad2.default, alt: "Complex blocuri - administrare imobile" })
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "u-pv-20 u-pv-40@tablet u-bg-white" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container" },
	          _react2.default.createElement(
	            "div",
	            { className: "o-layout o-layout--center o-layout--gutter-20" },
	            _react2.default.createElement(
	              "div",
	              { className: "o-layout__item u-1/1 u-1/2@tablet p-home__services-img" },
	              _react2.default.createElement("img", { src: _documenteAdministrareImobile2.default, alt: "documente administrare imobile" })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "o-layout__item u-1/1 u-1/2@tablet" },
	              _react2.default.createElement(
	                "h2",
	                { className: "c-section-h2" },
	                "Servicii administrare imobile"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Venim in intampinarea dumneavoastra cu servicii de inalta calitate, adaptate standardelor actuale de profil, oferind astfel transparenta cheltuielilor, solutii pentru diminuarea/eliminarea pierderilor, solutii pentru a asigura proprietarilor conditii maxime de confort."
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "u-color-grey-500" },
	                "Va punem la dispozitie urm\u0103toarele:"
	              ),
	              _react2.default.createElement(
	                "ul",
	                { className: "u-mb-0 o-list-05" },
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-link-simple", to: "/servicii/infiintare-asociatie-proprietari/" },
	                    "Servicii infiintare asociatii de proprietari"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-link-simple", to: "/servicii/administrare-financiara/" },
	                    "Servicii financiar-contabile"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-link-simple", to: "/servicii/plata-numerar/" },
	                    "Servicii plata numerar"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-link-simple", to: "/servicii/administrare-tehnica/" },
	                    "Servicii administrare tehnica"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-link-simple", to: "/servicii/cenzorat/" },
	                    "Servicii de cenzorat"
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: "c-link-simple", to: "/servicii/management-proiect/" },
	                    "Servicii de management de proiect"
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "u-pv-20 u-pv-40@tablet c-section-gradient" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container u-text-center@tablet" },
	          _react2.default.createElement(
	            "h2",
	            { className: "c-section-h2" },
	            "Suport pentru infiintarea asociatilor de proprietari"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "o-container o-container--text u-ph-0 u-mb-30" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Oferim suport pentru infiintarea asociatiilor de proprietari, preluarea tuturor facturilor de la dezvoltator si administrarea ulterioara a condominiului. "
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/servicii/infiintare-asociatie-proprietari/", className: "c-button" },
	            "VEZI SERVICII INFIINTARE ASOCIATIE PROPRIETARI"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "u-pv-20 u-pv-40@tablet u-bg-white" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container" },
	          _react2.default.createElement(
	            "div",
	            { className: "o-layout o-layout--center o-layout--gutter-20" },
	            _react2.default.createElement(
	              "div",
	              { className: "o-layout__item u-1/1 u-1/2@tablet" },
	              _react2.default.createElement(
	                "h2",
	                { className: "c-section-h2" },
	                "Zona vizata de noi cuprinde"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "o-layout" },
	                _react2.default.createElement(
	                  "ul",
	                  { className: "u-mr-30 u-mb-0" },
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Arena Nationala"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Aviatiei"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Primaverii"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Dorobanti"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Cotroceni"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Universitate"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Romana"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Unirii"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Muncii"
	                  )
	                ),
	                _react2.default.createElement(
	                  "ul",
	                  null,
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Pantelimon"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Salajan"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Trapezului"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Dristor"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Vitan"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Timpuri noi"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Tineretului"
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    "Tei"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "o-layout__item u-1/1 u-1/2@tablet p-home__locations-img" },
	              _react2.default.createElement("img", { src: _hartaPrestariServiciiAdministrareImobile2.default, alt: "Harta prestari servicii administrare imobile" })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "u-pv-20 u-pv-40@tablet c-section-gradient" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container u-text-center@tablet" },
	          _react2.default.createElement(
	            "h2",
	            { className: "c-section-h2" },
	            "Oferta personalizata"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "o-container o-container--text u-ph-0 u-mb-30" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Personalizam oferta noastra de administrare functie de fiecare imobil in parte si de solicitarile proprietarilor din imobil. Activitatea noastr\u0103 este bazat\u0103 pe transparen\u0163\u0103, profesionalism \u015Fi responsabilitate."
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/preturi/", className: "c-button" },
	            "SOLICITA O OFERTA PERSONALIZATA"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "section",
	        { className: "u-pv-20 u-pv-40@tablet" },
	        _react2.default.createElement(
	          "div",
	          { className: "o-container o-container--text" },
	          _react2.default.createElement(
	            "h2",
	            { className: "c-section-h2 u-text-center@tablet u-mb-20 u-mb-30@tablet" },
	            "Ultimele articole"
	          ),
	          articles.map(function (_ref, i) {
	            var node = _ref.node;
	            return _react2.default.createElement(_articleListItem2.default, { node: node, key: node.id });
	          })
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	IndexPage.propTypes = propTypes;
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/blocuri-aministrare-imobile-nicad.888f18ef.png";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/documente-administrare-imobile.dce09d4a.jpg";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/harta-prestari-servicii-administrare-imobile.ffe86c89.svg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6b4a8e98b139a065ee51.js